<template>
    <div>
        <Form
            :model="searchItem"
            :label-width="85"
            label-position="left"
            :disabled="loading"
            ref="formValidate" 
            :show-message="false"
            style="margin-top:20px"
        >
            <div class="searchRow">
                <div style="display:flex">
                    <FormItem label="中文描述">
                        <Input v-model="searchItem.chName" clearable/>
                    </FormItem>
                    <Button type="primary" style="margin-left:20px" @click="getData()">查询</Button>
                </div>
            </div>
        </Form>
        <Table
              stripe
              border
              :columns="columns"
              :loading="loading"
              :data="dataTable"
            >
            <template slot="slot1" slot-scope="{ row }">
                <Button type="primary" @click="openPop(1,row)">详情</Button>
            </template>
        </Table>
        <Page :total="this.totalNum" style="margin-top: 10px;display: flex;justify-content: flex-end;margin-bottom:10px" @on-change="pageChange" />
    </div>
</template>

<script>
import axios from 'axios'
export default {
    data(){
        return{
            loading:false,
            searchItem:{
                chName:''
            },
            totalNum: 0, //table数据总条数
            pageInfo: {
                pageNo: 1, //页码
                pageSize: 10, //每页数据条数
            },
            columns:[
                {
                    title: '序号',
                    type: 'index',
                    width: 60,
                    align: 'center'
                },
                {
                    title: '名称',
                    key: 'chName',
                    align: "center"
                },
                {
                    title: '操作',
                    align: "center",
                    slot: "slot1",
                    width: 100,
                }
            ],
            dataTable:[]
        }
    },
    created(){
        this.getData()
    },
    methods:{
        getData(){
            this.loading=true
            let json={
                remindId:'',
                chName:this.searchItem.chName,
                ...this.pageInfo
            }
            axios.post('/remindModule/selectAllRemindData',json).then(res => {
                this.loading=false
                if(res) {
                    this.dataTable=res.data
                    this.totalNum=Number(res.pageInfo.total)
                }
            })
        },
        openPop(index,row){
            this.$router.push({ 
                path: '/65EB9BBA2ADB3163059C1019FFC8EF81BA610C6A6F738319/A3FFBEBFDB713E27', 
                query: { remindId: row.remindId }
            })
        },
        pageChange(val){
            this.pageInfo.pageNo=val
            this.getData()
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/process/MyQuery/ReminderList.vue